import { render, staticRenderFns } from "./CardPayPage.vue?vue&type=template&id=c8836d2c&scoped=true&"
import script from "./CardPayPage.vue?vue&type=script&lang=js&"
export * from "./CardPayPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPayPage.vue?vue&type=style&index=0&id=c8836d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8836d2c",
  null
  
)

export default component.exports